import { createContext, useContext } from 'react';
import { API } from '@shared/types/api';

export interface CardNavigationItem {
  entityId: string;
  channelSlug: string;
  entityVariables?: API.ListWorkflowEntitiesQueryVariables;
  // explicit prev/next order, for a view whose rows aren't the entityVariables
  // query's own order (the tree flattens a hierarchy of separate level queries)
  entityIds?: string[];
  backTooltip?: string;
}

export interface CardNavigationState {
  stack: CardNavigationItem[];
  currentItem?: CardNavigationItem;
  previousItem?: CardNavigationItem;
  addStackItem: (item: CardNavigationItem) => void;
  updateCurrentItem: (target: CardNavigationItem) => void;
  removeCurrentItemAfterNavigation: () => void;
  resetStackAfterNavigation: () => void;
}

const defaultCardNavigationContext: CardNavigationState = {
  stack: [],
  currentItem: undefined,
  previousItem: undefined,
  addStackItem: () => undefined,
  updateCurrentItem: () => undefined,
  removeCurrentItemAfterNavigation: () => undefined,
  resetStackAfterNavigation: () => undefined,
};

export const CardNavigationContext = createContext<CardNavigationState>(
  defaultCardNavigationContext,
);

export function useCardNavigationContext(): CardNavigationState {
  return useContext(CardNavigationContext);
}
